import { defineStore } from "pinia";
import axios from "axios";
import { userManager } from "@/auth/oidc";
import { clearCustomer, customerForUser } from '@/utils/customerSelection';

export const useAuthStore = defineStore("auth", {
  state: () => ({
    user: null,
  }),
  getters: {
    isAuthenticated: (s) => !!s.user && !s.user.expired,
  },
  actions: {
    async init() {
      const user = await userManager.getUser();

      if (user && !user.expired) {
        this.user = user;
        if (!customerForUser(user.profile.sub)) clearCustomer();
        //axios.defaults.headers.common.Authorization = `Bearer ${user.access_token}`;

        // // ✅ Fetch latest AccessRights from backend
        //  try {
        //   const res = await axios.get("/api/AccessRights");
        //   localStorage.setItem("claims", JSON.stringify(res.data || []));
        //    console.log("[AuthStore] AccessRights:", res.data);
        // } catch (err) {
        //    console.error("[AuthStore] Failed to fetch AccessRights:", err);
        //  }
      } else {
        this.user = null;
        delete axios.defaults.headers.common.Authorization;
      }
    },
    login(returnPath = "/") {
      // pass the intended URL in the "state"
      return userManager.signinRedirect({ state: returnPath });
    },
    async completeLogin() {
      try {
        // finishes code→token and returns the user
        const user = await userManager.signinRedirectCallback();
        this.user = user;
        clearCustomer();
        axios.defaults.headers.common.Authorization = `Bearer ${user.access_token}`;
        // the OIDC client parses your "state" for you:
        return "/start";
      } catch (err) {
        // "No matching state found in storage" happens when the callback
        // runs against already-consumed state (e.g. the handler fired twice
        // or /callback was reloaded). If a valid user is already stored from
        // the first pass, treat the login as successful instead of crashing.
        const existing = await userManager.getUser();
        if (existing && !existing.expired) {
          this.user = existing;
          clearCustomer();
          axios.defaults.headers.common.Authorization = `Bearer ${existing.access_token}`;
          return "/start";
        }
        // No usable session — restart the login flow from scratch.
        console.error("[AuthStore] completeLogin failed:", err);
        throw err;
      }
    },
    logout() {
      clearCustomer();
      return userManager.signoutRedirect();
    },
    async completeLogout() {
      await userManager.signoutRedirectCallback();
      this.user = null;
      delete axios.defaults.headers.common.Authorization;
    },
  },
});
